<template>
    <div class="about">
        <navs></navs>
        <div class="all_box">
            <div class="about_top">
                <div class="top_left">
                    <h3>公司简介</h3>
                    <p>Company profile</p>
                </div>
                <div class="top_right">
                    <p>浙江橙兰外包服务有限公司坚持专注于人力资源服务行业，成立至今始终秉承成为最专业、最具竞争力和最具品牌价值的人力资源服务行业的引领者。</p>
                </div>
            </div>
        </div>
        <div class="banner">
            <img src="@/assets/img/about_banner.png">
        </div>
        <div id="aaa"></div>
        <div class="all_box">
            <div class="about_introduction">
                <div class="introduction_left">
                    <h4>浙江橙兰<span>baobobo.cn</span></h4>
                    <div class="introduction_box">
                        <p>我们对外服务为“劳务外包、劳务派遣、人事代理、社保代理、薪酬服务，代发工资、猎头服务”等企业人力资源服务。已经和全国范围数百家优秀企业建立了稳定双赢的人力资源服务关系，赢得了一定的品牌知名度和美誉度。浙江橙兰致力于成为最专业的人力资源全面解决方案提供商，成为客户最值得信赖的人力资源合作伙伴。
                        </p>
                        <p>我们的梦想：成为人力资源行业的中国样本！</p>
                        <p>我们的使命：最优服务，国际化标准，创造最全面的人力资源平台，让员工达成目标与梦想，为客户提供核心价值，让工作改变生活。</p>
                        <p>我们的价值观：以成为最受人尊敬的企业为愿景，以诚信、创新、卓越、团队合作为基石，为客户提供最优质的服务。</p>
                    </div>
                </div>
                <div class="introduction_right">
                    <img src="@/assets/img/about_introduction.png">
                </div>
            </div>


            <div id="bbb"></div>
            <div class="partnerSchool">
                <div class="partnerSchool_title">
                    <h4>Partner schools<span>合作院校</span></h4>
                    <div class="schools_box">
                        <div class="schools_item">
                            · 嘉兴职业技术学院
                        </div>
                        <div class="schools_item">
                            · 浙江交通技师学院
                        </div>
                        <div class="schools_item">
                            · 长兴县职业技术教育中心学校
                        </div>
                        <div class="schools_item">
                            · 浙江龙泉市中等职业学校
                        </div>
                        <div class="schools_item">
                            · 江苏徐州工业职业技术学校
                        </div>
                        <div class="schools_item">
                            · 徐州市金宏职业技术学校
                        </div>
                        <div class="schools_item">
                            · 苏州中山进修学院
                        </div>
                        <div class="schools_item">
                            · 江苏省沛县乾坤职业技术学校
                        </div>
                        <div class="schools_item">
                            · 安徽省黄山市旅游经济学校
                        </div>
                        <div class="schools_item">
                            · 安徽省旌德县高级职业中学
                        </div>
                        <div class="schools_item">
                            · 安徽省机电工程学校
                        </div>
                        <div class="schools_item">
                            · 安徽省太糊当代职业技术学校
                        </div>
                        <div class="schools_item">
                            · 合肥铁路工程学校
                        </div>
                        <div class="schools_item">
                            · 中国人民解放军海天专修学院
                        </div>
                        <div class="schools_item">
                            · 河北石家庄工程技术学校
                        </div>
                        <div class="schools_item">
                            · 河北张家口市机械工业学校
                        </div>
                        <div class="schools_item">
                            · 河南省新乡县技工学校
                        </div>
                        <div class="schools_item">
                            · 河南省许昌中原职业中专
                        </div>
                        <div class="schools_item">
                            · 河南省化学工业高级技工学校
                        </div>
                        <div class="schools_item">
                            · 江西南昌工业技工学校
                        </div>
                        <div class="schools_item">
                            · 江西省化工技术学校
                        </div>
                        <div class="schools_item">
                            · 江西省轻工业学校
                        </div>
                        <div class="schools_item">
                            · 九江职业技术学院
                        </div>
                        <div class="schools_item">
                            · 江西科技学院
                        </div>
                        <div class="schools_item">
                            · 山东新泰市职业中等学校
                        </div>
                        <div class="schools_item">
                            · 山东华宇职业技术学院
                        </div>
                        <div class="schools_item">
                            · 常德职业中专学校
                        </div>
                        <div class="schools_item">
                            · 湖南岳阳市人民经常学校
                        </div>
                        <div class="schools_item">
                            · 湖南长沙服装工业技工学校
                        </div>
                        <div class="schools_item">
                            · 湖南轻工高级技工学校
                        </div>
                        <div class="schools_item">
                            · 湖北黄州理工学校
                        </div>
                        <div class="schools_item">
                            · 湖北江汉石油高级技工学校
                        </div>
                        <div class="schools_item">
                            · 湖北省创业技工学校
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <friend></friend>
        <foots @navChange="initDw"></foots>
    </div>
</template>
<script>
    import friend from '@/components/friend.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    export default {
        name: 'about',
        data() {
            return {

            }
        },
        mounted() {
            this.initDw()
        },
        methods: {
            //初始化定位
            initDw(e) {
                if (e) {
                    if(e == 1){
                        document.getElementById("aaa").scrollIntoView();
                    }
                    if(e == 2){
                        document.getElementById("bbb").scrollIntoView();
                    }
                } else {
                    if (this.$route.params) {
                        if (this.$route.params.type == 1) {
                            //公司介绍
                            document.getElementById("aaa").scrollIntoView();
                        }
                        if (this.$route.params.type == 2) {
                            // 合作院校
                            document.getElementById("bbb").scrollIntoView();
                        }
                    }
                }



            }
        },
        components: {
            navs,
            foots,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .banner {
        width: 100%;

        img {
            width: 100%;
        }
    }

    .about_top {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 105px 0 78px;
    }

    .top_left {
        text-align: left;

        h3 {
            font-size: 34px;
            font-weight: 400;
            color: #333;
            margin: 0;
            margin-bottom: 15px;
        }

        p {
            font-size: 14px;
            color: #666;
            margin: 0;
        }
    }

    .top_right {
        font-size: 18px;
        font-weight: 290;
        line-height: 36px;
        color: #333;
        margin: 0;
        width: 50%;
        text-align: left;

        p {
            margin: 0;
        }
    }

    .about_introduction {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 94px 0 100px;
    }

    .introduction_left {
        text-align: left;
        width: 40%;

        h4 {
            font-size: 24px;
            color: #333;
            font-weight: 400;
            margin: 0;

            span {
                font-size: 14px;
                color: #333;
                font-weight: 290;
                margin-left: 21px;
            }
        }
    }

    .introduction_box {
        p {
            font-size: 16px;
            color: #666;
            line-height: 30px;
            margin: 30px 0;
        }
    }

    .schools_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .schools_item {
        width: 20%;
        text-align: left;
        font-size: 16px;
        color: #666;
        font-weight: 400;
        margin: 15px 0;
    }

    .partnerSchool_title {
        h4 {
            position: relative;
            font-size: 26px;
            font-weight: 700;
            color: #333;
            text-align: left;
            padding-left: 40px;
            margin: 0;
            margin-bottom: 60px;

            span {
                font-size: 18px;
                color: #333;
                font-weight: 400;
                margin-left: 22px;
            }
        }

        h4:after {
            content: '';
            width: 16px;
            height: 16px;
            border-radius: 16px;
            background: #F08300;
            position: absolute;
            left: 0;
            top: 5px;
        }
    }
</style>